import { render, staticRenderFns } from "./albumItems.vue?vue&type=template&id=eb842dc8&scoped=true"
import script from "./albumItems.vue?vue&type=script&lang=js"
export * from "./albumItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb842dc8",
  null
  
)

export default component.exports